import { render, staticRenderFns } from "./LeftMenuProfile.vue?vue&type=template&id=008b753f&"
import script from "./LeftMenuProfile.vue?vue&type=script&lang=js&"
export * from "./LeftMenuProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports